import React from "react";
import ClearFilter from "../components/ClearFilter";
import Header from "../components/Header";
import Pagination from "../components/Pagination";
import TransactionContainer from "../components/TransactionContainer";

const AllTransactions = () => {
  return (
    <div className='transactions-page'>
      <Header />
      <ClearFilter />
      <TransactionContainer />
      <Pagination />
    </div>
  );
};

export default AllTransactions;
